import { createSelector } from 'reselect';
import { isNil, some } from 'lodash';

export const objectSelectorFactory = (selector) =>
  createSelector(selector, (object) => ({
    data: object.get('data'),
    loading: object.get('loading'),
    error: object.get('error'),
  }));

export const dataSelectorFactory = (selector) =>
  createSelector(selector, ({ data }) => data && data);
export const isLoadingSelectorFactory = (selector) =>
  createSelector(selector, ({ loading }) => loading && !!loading);
export const isErrorSelectorFactory = (selector) =>
  createSelector(selector, ({ error }) => error && !!error);

export const needFetchDataSelectorFactory = (selector) =>
  createSelector(selector, ({ data, loading }) => isNil(data) || !loading);

export const isErrorArraySelectorFactory = (selectorsArray) =>
  createSelector([...selectorsArray], (...results) =>
    some(results, (result) => result && result.get('error')),
  );
export const isLoadingArraySelectorFactory = (selectorsArray) =>
  createSelector([...selectorsArray], (...results) =>
    some(
      results,
      (result) => (result && result.get('loading')) || (result && isNil(result.get('data'))),
    ),
  );
